import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

// Escape CSV field values
const escapeCsvValue = (value) => {
  if (value == null) return "";
  const str = String(value);
  if (str.includes(",") || str.includes('"') || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`; // Double quotes inside fields must be escaped
  }
  return str;
};

const downloadCsv = (data, location) => {
  const generateTitle = (path) => {
    if (!path) return "data-export";
    let title = path.split("?")[0].replace(/\//g, "-").replace(/^-|-$/g, "");
    return title || "data-export";
  };

  const generatedTitle = generateTitle(location.pathname + location.search);
  const timezoneVal = sessionStorage.getItem("timezone") || "UTC";

  const rows = Array.isArray(data) ? data : data.split("\n");

  if (rows.length === 0) return; // No data to download

  // Prepare CSV
  const csvRows = [];

  const headers = rows[0].split(","); // Header columns
  csvRows.push(headers.map(escapeCsvValue).join(",")); // Escape headers safely

  // Find time column indexes
  const timeColumnIndices = headers
    .map((column, index) => (column.includes("Time") ? index : -1))
    .filter((index) => index !== -1);

  // Process data rows
  for (let i = 1; i < rows.length; i++) {
    if (!rows[i].trim()) continue; // skip empty lines
    const rawValues = rows[i].split(",");

    const rowValues = rawValues.map((value, index) => {
      if (timeColumnIndices.includes(index) && value && value !== "0") {
        return dayjs.unix(value).tz(timezoneVal).format("YYYY-MM-DD HH:mm:ss");
      }
      return value;
    });

    csvRows.push(rowValues.map(escapeCsvValue).join(","));
  }

  const csvContent = "\uFEFF" + csvRows.join("\n"); // BOM + CSV

  // Create download link
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", `${generatedTitle}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};

export default downloadCsv;
